export const guestTokenTTLSeconds = 60 * 60 * 24 * 14
